import { useQuery } from "@tanstack/react-query";
import { Circle, LayersControl, Popup } from "react-leaflet";
import { getZones } from "../api/dronesAPI";
import { useAuthStore } from "../store/authStore";
import { useEffect } from "react";
import { useMapStore } from "../store/mapStore";
import { click } from "@testing-library/user-event/dist/click";

const { Overlay } = LayersControl;
const ZonesMapView = () => {
    const { token } = useAuthStore((state) => state)
    const { setZoneInfo, setShowZoneInfoPopup } = useMapStore((state) => state)
    const zones = useQuery({
        queryFn: getZones,
        queryKey: ["zones", token],
        refetchOnWindowFocus: false,
    });

    return (
        <>
            <Overlay checked name="Overlay Layer">
                {zones?.data?.data?.data?.length > 0 && zones?.data?.data?.data?.map((zone, index) => {
                    return (
                        <>
                            {
                                zone?.zoneType === "red" ?
                                    <Circle
                                        key={index}
                                        center={[zone?.lat, zone?.lng]}
                                        pathOptions={{ fillColor: "red", fillOpacity: 0.5, color: "red" }}
                                        radius={zone?.radius}
                                        eventHandlers={{
                                            click: (e) => {
                                                setShowZoneInfoPopup(true)
                                                setZoneInfo({
                                                    position: `${zone.lat} , ${zone.lng}`,
                                                    zoneCategory: zone.zoneType,
                                                    radius: zone.radius,
                                                    name: zone.name
                                                })
                                            }

                                        }}
                                    >
                                        <Popup>{zone?.name}</Popup>
                                    </Circle> :
                                    zone?.zoneType === "yellow" ?
                                        <Circle
                                            key={index}
                                            center={[zone?.lat, zone?.lng]}
                                            pathOptions={{ fillColor: "yellow", fillOpacity: 0.5, color: "yellow" }}
                                            radius={zone?.radius}
                                        >
                                            <Popup>Yellow Zone</Popup>
                                        </Circle> : ""
                            }
                        </>
                    );
                })}
            </Overlay>
        </>
    )
}

export default ZonesMapView